import { render, staticRenderFns } from "./ConfirmBeforeLeaving.vue?vue&type=template&id=6c4cf84e&scoped=true&"
import script from "./ConfirmBeforeLeaving.vue?vue&type=script&lang=ts&"
export * from "./ConfirmBeforeLeaving.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmBeforeLeaving.vue?vue&type=style&index=0&id=6c4cf84e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4cf84e",
  null
  
)

export default component.exports